const mutations = {
  SET_TECHNICIANS(state, { technicians }) {
    state.technicians = technicians
  },
}
export default mutations
